import ContextConditionalComponent from './ContextConditional.component';
import model from './ContextConditional.model';

export { ContextConditionalComponent, model };

export default ContextConditionalComponent;
